module.exports = "<div [formGroup]=\"formGroup\">\n  <div class=\"answer-choice-view-container\" [ngClass]=\"{'hidden-answer': toggle === 'hidden'}\">\n    <div *ngIf=\"toggle === 'visible'\">\n      <span [innerHtml]=\"answerChoicePrompt.value | mpSafeHtml\"></span>\n    </div>\n  </div>\n  <button (click)=\"toggleAnswer()\" class=\"btn btn_toggle pull-right\">\n    {{toggleButtonText}}\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/choice-views/hide-show-choice-view/hide-show-choice-view.html
// module id = E+Ma
// module chunks = 3